export const ANNOUNCEMENTS_TABS = [
  {
    label: 'Published Announcements',
    path: '/announcements',
    value: 0,
    ariaLabel: 'announcements-tab'
  },
  {
    label: 'Draft Announcements',
    path: '/announcements/drafts',
    value: 1,
    ariaLabel: 'draft-announcement-tab'
  }
];

export default ANNOUNCEMENTS_TABS;
